import React, { useState } from 'react';

const FALLBACK_COLORS = [
  'bg-blue-500',
  'bg-violet-500',
  'bg-emerald-500',
  'bg-amber-500',
  'bg-rose-500',
  'bg-cyan-500',
  'bg-orange-500',
  'bg-teal-500',
];

function getFallbackColor(ticker: string): string {
  let hash = 0;
  for (let i = 0; i < ticker.length; i++) {
    hash = ticker.charCodeAt(i) + ((hash << 5) - hash);
  }
  return FALLBACK_COLORS[Math.abs(hash) % FALLBACK_COLORS.length];
}

const SIZE_MAP = {
  xs:  { wrapper: 'w-5 h-5',   text: 'text-[8px]'  },
  sm:  { wrapper: 'w-6 h-6',   text: 'text-[9px]'  },
  md:  { wrapper: 'w-8 h-8',   text: 'text-[11px]' },
  lg:  { wrapper: 'w-10 h-10', text: 'text-[13px]' },
};

interface TickerIconProps {
  ticker: string;
  size?: keyof typeof SIZE_MAP;
  className?: string;
}

export function TickerIcon({ ticker, size = 'sm', className = '' }: TickerIconProps) {
  const [imgError, setImgError] = useState(false);
  const { wrapper, text } = SIZE_MAP[size];
  const fallbackColor = getFallbackColor(ticker);
  const logoUrl = `https://assets.parqet.com/logos/symbol/${encodeURIComponent(ticker)}`;

  return (
    <div
      className={`
        ${wrapper} rounded-full flex-shrink-0 overflow-hidden
        ring-1 ring-gray-200 dark:ring-[#1d2d47]
        bg-white dark:bg-[#141e30]
        ${className}
      `}
    >
      {!imgError ? (
        <img
          src={logoUrl}
          alt={ticker}
          className="w-full h-full object-contain"
          onError={() => setImgError(true)}
        />
      ) : (
        <div className={`w-full h-full ${fallbackColor} flex items-center justify-center`}>
          <span className={`${text} font-bold text-white leading-none`}>
            {ticker.charAt(0)}
          </span>
        </div>
      )}
    </div>
  );
}
